const timers = {
  forms: {}
};

const clearTimer = ({ type = 'forms', instanceToken, timerId }) => {
  if (!timers[type][instanceToken]) return;

  const timer = timers[type][instanceToken][timerId];
  if (!timer) return;

  clearTimeout(timers[type][instanceToken][timerId]);
  clearInterval(timers[type][instanceToken][timerId]);
  delete timers[type][instanceToken][timerId];
};

const clearTimers = ({ instanceToken }) => {
  if (!timers.forms[instanceToken]) return;
  Object.keys(timers.forms[instanceToken], timerId => {
    clearTimer({ instanceToken, timerId });
  });
};

const addTimer = ({
  type = 'forms',
  instanceToken,
  timerId,
  timer,
  delay = 0,
  timerType = 'timeout'
}) => {
  clearTimer({ type, instanceToken, timerId });

  const timerAction = () => {
    timer();
    delete timers[type][instanceToken][timerId];
  };

  if (!timers[type][instanceToken]) {
    timers[type][instanceToken] = {};
  }

  timers[type][instanceToken][timerId] =
    timerType === 'interval'
      ? setInterval(timerAction, delay)
      : setTimeout(timerAction, delay);
};

const isTimerExist = ({ type = 'forms', instanceToken, timerId }) => {
  if (!timers[type][instanceToken]) return false;
  return !!timers[type][instanceToken][timerId];
};

export default {
  addTimer,
  isTimerExist,
  clearTimer,
  clearTimers
};



// WEBPACK FOOTER //
// ./src/store/forms/utils/formsTimers.js